/**
* Message utility functions
*/

/**
* Generate a unique message ID
*/
export function generateMessageId(prefix: string): string {
    return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`
}
